export default __webpack_public_path__ + "static/media/newPlan.8b1fae44.jpg";